/**
 * Highcharts Chart Wrapper Component
 * Wraps Highcharts charts with info icon and consistent styling
 */
import React from 'react';
import ChartInfoIcon from './ChartInfoIcon.jsx';

export default function HighchartsChartWrapper({ 
  children, 
  title, 
  definition, 
  limitations,
  futureMonthsNote = false,
}) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <div style={styles.titleRow}>
          <h3 style={styles.title}>{title}</h3>
          <ChartInfoIcon
            title={title}
            definition={definition}
            limitations={limitations}
            futureMonthsNote={futureMonthsNote}
          />
        </div>
      </div>
      <div style={styles.chartContainer}>
        {children}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    minHeight: '400px',
  },
  header: {
    marginBottom: '16px',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#111827',
    margin: 0,
  },
  chartContainer: {
    position: 'relative',
  },
};
